import { call, put, takeLatest } from "redux-saga/effects";
import { CommonAPI } from "../../../api/commonAPI";
import {
  GET_RATING_REVIEWS_REQUEST,
  GET_RATING_REVIEWS_SUCCESS,
  GET_RATING_REVIEWS_ERROR
} from "../../actions";

function* workerRatingReviews(action: {
  type: string;
  payload: any;
  meta?: { period?: string };
}): Generator<any> {
  try {
    const response: any = yield call(
      CommonAPI.getRatingReviews,
      action.payload
    );
    // Filter only all_time_income and unique_reservations_* keys
    let filtered: Record<string, any> = {};
    const fullData = response?.data || {};
    // Determine period key
    let period =
      action?.meta?.period ||
      (action.payload && action.payload.param) || "summary";
    yield put({
      type: GET_RATING_REVIEWS_SUCCESS,
      payload: { [period]: fullData },
    });
  } catch (error) {
    yield put({ type: GET_RATING_REVIEWS_ERROR, payload: error });
  }
}

export function* watcherRatingReviews() {
  yield takeLatest(GET_RATING_REVIEWS_REQUEST, workerRatingReviews);
}
